export default "__VITE_ASSET__C71bnWcD__"